<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>咨询服务</h2>
      <span>CONSULTATION SERVICE</span>
    </div>

    <div class="content">
      凯泰铭立志以知识和技术为手段，以协助景区客户解决复杂的决策问题为目的向有需求的景区提供智力服务
    </div>

    <div class="body">
      <div class="level-1">
        <img src="@/assets/images/product/consulting/1.png" alt="" srcset="">
        <div class="card">
          <h4>TICKETING SYSTEM</h4>
          <h5>票务系统解决方案咨询</h5>
          <p>梳理跨部门协同关系</p>
          <p>打破各部门协作壁垒</p>
          <p>建立规范化工作流程</p>
          <p>OTA等渠道对接误区</p>
          <p>财务核销不准确判定</p>
        </div>
        <div class="card-bg"></div>
      </div>
      <div class="level-2">
        <img src="@/assets/images/product/consulting/2.png" alt="" srcset="">
        <div class="card">
          <h4>INTELLIGENT SCENIC AREA</h4>
          <h5>智慧化景区解决方案咨询</h5>
          <p>管理流程的顶层设计</p>
          <p>规范岗位流程管理</p>
          <p>大数据灵活运用方案</p>
          <p>景区系统大并发解决方案</p>
        </div>
        <div class="card-bg"></div>
      </div>
      <div class="level-1">
        <img src="@/assets/images/product/consulting/3.png" alt="" srcset="">
        <div class="card">
          <h4>OPERATION AND SECURITY</h4>
          <h5>运维安全解决方案咨询</h5>
          <p>票务系统等保2.0二级、三级咨询</p>
          <p>票务系统技术咨询</p>
          <p>景区周边系统运维咨询</p>
        </div>
        <div class="card-bg"></div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
      font-size: 24px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
    width: 100%;
    margin: 20px 0;

    h4 {
      font-size: 0.14rem;
    }

    h5 {
      font-size: 0.12rem;
      margin-bottom: 0.5rem;
    }

    p {
      margin: 0;
      font-size: 0.08rem;
      line-height: 0.15rem;
    }

    > .level-1 {
      width: 100%;
      position: relative;

      > img {
        width: 70%;
        border: 1px dashed gray;
        z-index: 1;
      }

      > .card {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 18%;
        right: 20px;
        z-index: 3;
        border-radius: 0;
        padding: 40px;
      }

      > .card-bg {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 22.3%;
        right: 0;
        background-color: rgba(20, 90, 132, 1);
        z-index: 2;
      }
    }

    > .level-2 {
      width: 100%;
      position: relative;
      text-align: right;
      margin: 30px 0;

      > img {
        width: 70%;
        border: 1px dashed gray;
        right: 0;
        z-index: 1;
      }
      > .card {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 18%;
        left: 20px;
        z-index: 3;
        border-radius: 0;
        padding: 40px;
        text-align: left;
      }
      > .card-bg {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 22.3%;
        background-color: rgba(20, 90, 132, 1);
        z-index: 2;
      }
    }

    h4,
    h5 {
      margin-bottom: 0.05rem;
    }
  }
}
</style>